import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { RecAnime } from './RecAnime';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RecAnime />
);
